import { Button, Tooltip } from '@chakra-ui/react';
import React, { useState } from 'react';
import { FaImage } from 'react-icons/fa';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const PickupImageLightbox = React.memo(({ pickup }) => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [imageUrls, setImageUrls] = useState([]);

    const hasImages = pickup?.attachments?.some(
        (a) => !a.deletedAt
    );

    const handleOpen = () => {
        const urls =
            pickup?.attachments
                ?.filter((a) => !a.deletedAt)
                ?.map((a) =>
                    a.fileUrl.startsWith('/uploads/couriers-attachments/')
                        ? process.env.REACT_APP_IMAGES_LOCAL + a.fileUrl.replace('/uploads/couriers-attachments', '/ups/uploads/couriers-attachments')
                        : process.env.REACT_APP_IMAGES + a.fileUrl.replace('/uploads', '/ups/uploads')
                ) || [];


        setImageUrls(urls);
        setLightboxIndex(0);
        setLightboxOpen(true);
    };

    if (!hasImages) return null;

    return (
        <>
            <Tooltip label="View Pickup Images" placement="top">
                <Button size="xs" colorScheme="orange" onClick={handleOpen}>
                    <FaImage />
                </Button>
            </Tooltip>

            {lightboxOpen && imageUrls.length > 0 && (
                <Lightbox
                    mainSrc={imageUrls[lightboxIndex]}
                    nextSrc={imageUrls[(lightboxIndex + 1) % imageUrls.length]}
                    prevSrc={imageUrls[(lightboxIndex + imageUrls.length - 1) % imageUrls.length]}
                    onCloseRequest={() => setLightboxOpen(false)}
                    onMovePrevRequest={() =>
                        setLightboxIndex((lightboxIndex + imageUrls.length - 1) % imageUrls.length)
                    }
                    onMoveNextRequest={() =>
                        setLightboxIndex((lightboxIndex + 1) % imageUrls.length)
                    }
                    clickOutsideToClose={true}
                />
            )}
        </>
    );
});

export default PickupImageLightbox;
